import { device } from '@mercadoni/sinister/dist/cjs/shared/utils'
import { App } from '@mercadoni/sinister/dist/lib/src/entities/clientModel'

const clientIsEnabled = (params: {
  clientConfiguration?: App
  device: typeof device
}) => {
  const { clientConfiguration = { enabled: false }, device = {} } = params || {}

  // Memoize CSR check and access point detection
  const isCSR = typeof window !== 'undefined'
  const accessPoint = isCSR
    ? (window as Window & { accessPoint?: string })?.accessPoint
    : undefined

  // Early return for invalid configurations
  if (!clientConfiguration || !device || accessPoint === 'APP') {
    return false
  }

  // Check if client configuration has required properties
  const hasClientConfig = Object.keys(clientConfiguration).length > 0
  const hasDeviceInfo = Object.keys(device).length > 0

  if (!hasClientConfig || !hasDeviceInfo) {
    return false
  }

  // Check basic requirements
  if (!clientConfiguration.enabled || !device.isMobile() || device.isBot()) {
    return false
  }

  // Check platform-specific requirements
  if (device.isAndroid()) {
    return !!clientConfiguration.android?.deepLink
  }

  if (device.isiOs()) {
    return !!(
      clientConfiguration.ios?.appName && clientConfiguration.ios?.appStoreUrl
    )
  }

  return false
}

export default clientIsEnabled
